import React, { useState } from "react";
import { AiOutlineEye, AiOutlineEyeInvisible } from "react-icons/ai";

function ResetPasswordModel({
  onCloseResetPasswordModel,
  showResetPasswordModal,
}) {
  const [showPass, setShowPass] = useState({
    password: false,
    confirmPassword: false,
  });

  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");

  const togglePasswordVisibility = (field) => {
    setShowPass((prevState) => ({
      ...prevState,
      [field]: !prevState[field],
    }));
  };

  return (
    <div>
      <div
        className={`fixed inset-0 flex items-end justify-center text-black dark:text-white ${
          showResetPasswordModal ? "block" : "hidden"
        }`}
      >
        <div
          className="fixed inset-0 bg-black opacity-50 "
          onClick={onCloseResetPasswordModel}
        ></div>
        <div className="bg-white dark:bg-[#000] w-full md:w-1/2  p-5  pb-10 shadow-lg transform transition-transform duration-300  rounded-t-[56px]">
          <div className="flex justify-center ">
            <div className="border-2 border-[#5D5FEF] w-32 mt-3 mb-8"></div>
          </div>

          <div className="">
            <div className="  mt-14 px-3">
              <div className="space-y-3">
                <p className="font-[900] text-[30px] ">Reset Password</p>
                <p className="text-[20px] font-bold ">
                  Set the new password for your account so you can login and
                  access all the features.
                </p>
              </div>
            </div>

            <div className="flex flex-col items-center px-12 mt-10 ">
              <div className="space-y-3 ml-[20px] mr-[20px]">
                <div>
                  <p className="font-[400] text-[20px] mb-3">Password</p>
                  <div className="w-96 border border-[#D9D9D9] rounded-[25px] bg-[#D9D9D9] h-[50px] mb-14 flex items-center px-4">
                    <input
                      type={showPass.password ? "text" : "password"}
                      className="w-96 focus:outline-none rounded-[25px] bg-[#D9D9D9] dark:text-black  h-full px-2"
                      value={password}
                      onChange={(e) => setPassword(e.target.value)}
                    />
                    {showPass.password ? (
                      <AiOutlineEyeInvisible 
                        className="w-6 h-6 cursor-pointer"
                        onClick={() => togglePasswordVisibility("password")}
                      />
                    ) : (
                      <AiOutlineEye 
                        className="w-6 h-6 cursor-pointer"
                        onClick={() => togglePasswordVisibility("password")}
                      />
                    )}
                  </div>
                </div>

                <div>
                  <p className="font-[400] text-[20px] mb-3">
                    Confirm Password
                  </p>
                  <div className="w-full border border-[#D9D9D9] rounded-[25px] bg-[#D9D9D9] h-[50px] mb-14 flex items-center px-4">
                    <input
                      type={showPass.confirmPassword ? "text" : "password"}
                      className="w-full focus:outline-none rounded-[25px] bg-[#D9D9D9] h-full dark:text-black  px-2"
                      value={confirmPassword}
                      onChange={(e) => setConfirmPassword(e.target.value)}
                    />
                    {showPass.confirmPassword ? (
                      <AiOutlineEyeInvisible 
                        className="w-6 h-6 cursor-pointer"
                        onClick={() => togglePasswordVisibility("confirmPassword")}
                      />
                    ) : (
                      <AiOutlineEye 
                        className="w-6 h-6 cursor-pointer"
                        onClick={() => togglePasswordVisibility("confirmPassword")}
                      />
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="flex flex-col items-center   px-12 ">
            <div className="">
              <button className="w-80 border border-[#D9D9D9] rounded-[25px] bg-[#2A71E8] p-5 text-white  mb-10 text-[15px] ">
                Continue
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ResetPasswordModel;
